import { render, staticRenderFns } from "./MainMenuNew.vue?vue&type=template&id=21828910&scoped=true&"
import script from "./MainMenuNew.vue?vue&type=script&lang=js&"
export * from "./MainMenuNew.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuNew.vue?vue&type=style&index=0&id=21828910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21828910",
  null
  
)

export default component.exports